var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_vm._v(" There's no configuration available for this app. ")])}
var staticRenderFns = []

export { render, staticRenderFns }